import React from 'react';
import { firebaseRoot } from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';

import VideoPlayer from '../components/Media/VideoPlayer';
import MathMarkup from '../components/MathMarkup/MathMarkup';

import MobileHeader from '../components/MobileHeader/MobileHeader';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import {generateLessonPoints} from './../models/PointCalc';

const Lesson = React.createClass({
    mixins: [ReactFireMixin],

    contextTypes: {
        history: React.PropTypes.object.isRequired,
        userRef: React.PropTypes.object.isRequired
    },

    getInitialState: function () {
        return {
            videoId: "",
            videoPosterId: ""
        };
    },

    async componentWillMount() {
        await firebaseRoot.child(`content/lessons/${this.props.params.lessonId}`).once("value", (snapshot) => {
            var data = snapshot.val();
            this.setState({videoId: data.videoId})
            this.setState({videoPosterId: data.videoPosterId})
        });

        generateLessonPoints(this.context.userRef.key(), this.props.params.lessonId);

    },

    render() {
        return (
            <div className="screen-wrap">
                <MobileHeader
                    lessonId={this.props.params.lessonId}
                    problemId={this.props.params.problemId}
                    bookId={this.props.params.bookId}
                    type='lesson'
                    // Don't show the back button on the root screen.
                    backButton={this.props.location.pathname.length > 1}
                />
                <div className="screen-content">
                    <div className="player-wrap">
                        {this.state.videoId ? <VideoPlayer videoId={this.state.videoId} videoPosterId={this.state.videoPosterId}/> : <div>Video kommer snart!</div>}

                    </div>
                    <section className="section">
                        <MathMarkup text={``}/>
                    </section>
                </div>
            </div>
        );
    }
});

export default Lesson;


/** WEBPACK FOOTER **
 ** ./src/screens/Lesson.js
 **/